import axiosInstance from '../../../api/api-service';

export const exportCSV = (params: {pestCompanyId: string; startDate?: string; endDate?: string}) => {
  return axiosInstance.get<Blob>('/export', {params, responseType: 'blob'});
};
